<template>
    <div class="card light-back max-full-width w-100">
        <div class="card-body">
            <div class="step-title">4. {{$t("Sisu")}}</div>

            <keep-alive>
                <div v-if="store.stepInfo.adType">
                    <component 
                        v-bind:is="componentMap[store.stepInfo.adType]"
                        :form-ready="formReady"   
                    ></component>
                </div>
            </keep-alive>
        </div>
    </div>
</template>

<script setup>
import { onActivated, onMounted, onBeforeUpdate, computed } from 'vue';
import { useMainStore } from '../includes/store';

import Advertisement from './Advertisement.vue';
import Condolence from './Condolence.vue';
import Greeting from './Greeting.vue';

onMounted(() => {
    checkEmpty();
});

onBeforeUpdate(() => {
    checkEmpty();
});

onActivated(() => {
    checkEmpty();
});

const componentMap = {
  advertisement: Advertisement,
  condolence: Condolence,
  greeting: Greeting,
};
    
const store = useMainStore();

const checkEmpty = () => {
    if (!store.stateLoaded) {
        return;
    }
    if (store.step === "adContent" && !store.stepInfo.client.name) {
        store.changeStep('client');
    }
}

const formReady = computed(() => {
    let incomplete = true;
    store.singlePrices.forEach(price => {
        if (parseFloat(price.single_price) > 0) {
            incomplete = false;
        }
    });
    if (store.stepInfo.adType === "advertisement") {
        let missingTranslations = 0;
        let adInfo = store.stepInfo.content.advertisement;

        if (!adInfo.translations) {
            adInfo.translations = {};
        }

        if (adInfo.translations && Object.keys(store.translationNeeds).length > 0) {
            Object.keys(adInfo.translations).forEach((translation) => {
                if (!Object.keys(store.translationNeeds).includes(translation)) {
                    return; //if no need to translate in this language
                }
                if (!adInfo.translations[translation] || adInfo.translations[translation].length < 3) {
                    missingTranslations++;
                }
            });
        }
        if (adInfo.category === null || (!adInfo.wantTranslation && missingTranslations > 0)) {
            incomplete = true;
        }
    }

    if (store.stepInfo.adType === "condolence" &&
        (store.stepInfo.content.condolence.name === null || store.stepInfo.content.condolence.name.length < 3)) {
        incomplete = true;
    }
    if (store.stepInfo.adType === "greeting" &&
        (store.stepInfo.content.greeting.name === null || store.stepInfo.content.greeting.name.length < 3)) {
        incomplete = true;
    }
    return !incomplete;
})
</script>
